'use strict'

import Api from '@/api/test.js'

const state = {
  error: null,
  test: null
}

const actions = {
  fetch ({commit}, {vacancyId}) {
    return Api.fetchOneByVacancyId(vacancyId)
      .then(data => commit('fetchSuccess', data))
      .catch(err => commit('fetchFailure', err))
  },

  disable ({commit, state}, model) {
    return Api.updateOne({ id: model.id, is_active: false })
      .then(data => commit('saveSuccess', data))
      .catch(err => commit('saveFailure', err))
  },

  enable ({commit, state}, model) {
    return Api.updateOne({ id: model.id, is_active: true })
      .then(data => commit('saveSuccess', data))
      .catch(err => commit('saveFailure', err))
  },

  addQuestion({ commit }, { testId, model }) {
    return Api.storeQuestions(testId, [model])
      .then(data => commit('addQuestionSuccess', data))
      .catch(err => commit('addQuestionFailure', err))
  },

  saveQuestion ({ commit, dispatch }, { testId, model }) {
    return Api.updateQuestions(testId, [model])
      .then(data => {})
      .catch(err => dispatch('global/setError', err, {root: true}))
  },

  saveQuestions ({ commit, dispatch }, { testId, models }) {
    return Api.updateQuestions(testId, models)
      .then(data => commit('updateQuestions', data))
      .catch(err => dispatch('global/setError', err, {root: true}))
  },

  deleteQuestion ({ commit, dispatch }, { testId, model }) {
    commit('deleteQuestion', model)
    return Api.removeQuestions(testId, [model])
      .then(data => {})
      .catch(err => dispatch('global/setError', err, {root: true}))
  },

  addAnswer ({ commit, dispatch }, { testId, questionId, model }) {
    return Api.storeAnswers(testId, questionId, [model])
      .then(data => commit('addAnswerSuccess', {questionId, model: data[0]}))
      .catch(err => dispatch('global/setError', err, {root: true}))
  },

  saveAnswer ({ commit, dispatch }, { testId, questionId, model }) {
    return Api.updateAnswers(testId, questionId, [model])
      // .then(data => commit('saveAnswerSuccess', {questionId, data}))
      .then(data => {})
      .catch(err => dispatch('global/setError', err, {root: true}))
  },

  deleteAnswer ({ commit, dispatch }, { testId, questionId, model }) {
    commit('deleteAnswerSuccess', {questionId, model})
    return Api.removeAnswers(testId, questionId, [model])
      .then(data => {})
      .catch(err => dispatch('global/setError', err, {root: true}))
  }
}

const mutations = {
  fetch (state) {
  },

  fetchSuccess (state, data) {
    state.test = data
  },

  fetchFailure (state, err) {
    state.error = err
  },

  setActive (state, { isActive }) {
  },

  updateQuestion (state, data) {
    state.test.questions = state.test.questions
      .map(question => question.id === data.id ? data : question)
  },

  updateQuestions (state, data) {
    state.test.questions = data
  },

  addQuestionSuccess (state, data) {
    state.test.questions = state.test.questions.concat(data)
  },

  addQuestionFailure (state, error) {
    state.error = error
  },

  deleteQuestion (state, data) {
    state.test.questions = state
      .test.questions.filter(question => question.id !== data.id)
  },

  addAnswerSuccess (state, {model, questionId}) {
    state.test.questions = state
      .test.questions.map(question => {
        return question.id === questionId
          ? { ...question, answers: question.answers.concat([model]) }
          : question
      })
  },

  saveAnswerSuccess (state, {data, questionId}) {
    state.test.questions = state
      .test.questions.map(question => question.id === questionId
          ? { ...question, answers: question.answers.map(answer => answer.id === data[0].id ? data[0] : answer) }
          : question)
  },

  updateAnswer (state, {model, questionId}) {
    state.test.questions = state
      .test.questions.map(question => question.id === questionId
        ? { ...question, answers: question.answers.map(answer => answer.id === model.id ? model : answer) }
        : question)
  },

  deleteAnswerSuccess (state, {model, questionId}) {
    state.test.questions = state
      .test.questions.map(question => question.id === questionId
          ? { ...question, answers: question.answers.filter(answer => answer.id !== model.id) }
          : question)
  },

  saveSuccess (state, data) {
    state.test = data
  },

  saveFailure (state, err) {
    state.error = err
  }
}

const setQuestionsPriority = (_questions) => {
  // todo: refactor unmutable without JSON
  let questions = JSON.parse(JSON.stringify(_questions))
  return questions.map(question => {
    let priority = 10
    question.answers = question.answers.map(answer => {
      answer.priority = priority
      priority += 10
      return answer
    })
    return question
  })
}

const getters = {
  error (state, getters) {
    return state.error
  },

  one (state, getters) {
    return state.test || {}
  },

  questions (state, getters) {
    return getters.one.questions || []
  },

  sortedQuestions (state, getters) {
    const questions = setQuestionsPriority([ ...getters.questions ])
    return questions.sort((a, b) => a.priority > b.priority ? 1 : -1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
